import { ILinkedObjectSpecifiable } from "../../../../documaker/domain/format/objects";

export interface IPresentableLinkedObjectIdentifier {
  toLinkedObjectIdentifier(): ILinkedObjectSpecifiable;
}

export function instanceOfIPresentableLinkedObjectIdentifier(instance: any): instance is IPresentableLinkedObjectIdentifier {
  return instance
      && instance.toLinkedObjectIdentifier;
}
